import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { getThemeStyle } from '../../styling/get-theme-style';
import { deprecate } from '../../utils/deprecate';
import { Inline } from '../inline';

var ArrowDown = function ArrowDown(_ref) {
  var extend = _ref.extend;
  return /*#__PURE__*/React.createElement(Inline, {
    extend: extend,
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.49987275 4.13397441L11.78483479.5 12.5 1.37426775 6.49986464 5.5.5 1.3743604l.7151756-.87426061z"
  }));
};

var ArrowUp = function ArrowUp(_ref2) {
  var extend = _ref2.extend;
  return /*#__PURE__*/React.createElement(Inline, {
    extend: extend,
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50012725 1.86602559L1.21516521 5.5.5 4.62573225 6.50013536.5 12.5 4.6256396l-.7151756.87426061z"
  }));
};

var ArrowLeft = function ArrowLeft(_ref3) {
  var extend = _ref3.extend;
  return /*#__PURE__*/React.createElement(Inline, {
    extend: extend,
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5 12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.36602559 5.99987275L5 11.28483479 4.12573225 12 0 5.99986464 4.1256396 0l.87426061.7151756z"
  }));
};

var ArrowRight = function ArrowRight(_ref4) {
  var extend = _ref4.extend;
  return /*#__PURE__*/React.createElement(Inline, {
    extend: extend,
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5 12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.63397441 6.00012725L0 .71516521.87426775 0 5 6.00013536.87436041 12l-.87426062-.7151756z"
  }));
};

var directionResolver = function directionResolver(direction, isRtl) {
  if (direction === 'right' && isRtl) {
    return 'left';
  }

  if (direction === 'left' && isRtl) {
    return 'right';
  }

  return direction;
};

var ArrowResolver = function ArrowResolver(_ref5) {
  var direction = _ref5.direction,
      extend = _ref5.extend;

  switch (direction) {
    case 'right':
      return /*#__PURE__*/React.createElement(ArrowRight, {
        extend: extend
      });

    case 'left':
      return /*#__PURE__*/React.createElement(ArrowLeft, {
        extend: extend
      });

    case 'up':
      return /*#__PURE__*/React.createElement(ArrowUp, {
        extend: extend
      });

    case 'down':
      return /*#__PURE__*/React.createElement(ArrowDown, {
        extend: extend
      });

    default:
      return null;
  }
};

var arrowStyle = function arrowStyle(_ref6) {
  var size = _ref6.size,
      color = _ref6.color;
  return {
    fill: color,
    height: size,
    width: size,
    stroke: 'transparent',
    transition: 'all 0.3s ease-out',
    transitionProperty: 'transform'
  };
};

export function Arrow(_ref7) {
  var _ref7$direction = _ref7.direction,
      direction = _ref7$direction === void 0 ? 'right' : _ref7$direction,
      _ref7$size = _ref7.size,
      size = _ref7$size === void 0 ? 10 : _ref7$size,
      color = _ref7.color;

  var _useFela = useFela(),
      theme = _useFela.theme;

  deprecate("<Arrow /> will be removed in 3.0.0. Use <Icon type=\"navigation-chevron".concat(direction === 'right' ? 'forward' : direction === 'left' ? 'back' : direction, "-24\" /> instead."), true);
  var styleProps = {
    size: size,
    color: color
  };
  return /*#__PURE__*/React.createElement(ArrowResolver, {
    direction: directionResolver(direction, theme.direction === 'rtl'),
    extend: [arrowStyle(styleProps), getThemeStyle('arrow', theme, styleProps)]
  });
}
Arrow.propTypes = {
  /** Any valid CSS color value */
  color: PropTypes.string,
  size: PropTypes.number,
  direction: PropTypes.oneOf(['up', 'down', 'right', 'left'])
};